<template>
    <div :class="rootClass">
        <strong class="tit_view"><em class="txt_point">지난주,</em> 카페 인기글</strong>
        <ul class="list_hotview" id="list_hotview">
            <card-item v-for="article in renderedArticles" :article="article" :config="config" ref="articleElements"></card-item>
        </ul>
        <ul class="nativead_wrap list_hotview" id="nativead_wrap"></ul>
        <div class="wrap_btn">
            <button type="button" class="btn_item btn_moreview" @click="renderMoreArticles" v-if="renderedArticleCount < articles.length">더보기</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import CardItem from './CardItem.vue';

export default {
    components: {
        CardItem
    },
    props: {
        config: Object,
        articles: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            MORE_VIEW_SIZE: 10,
            renderedArticleCount: 10
        };
    },
    computed: {
        rootClass() {
            return {
                'view_card': true,
                'view_hotview': true,
                'view_card--no_contents': this.articles.length === 0
            };
        },
        renderedArticles() {
            return this.newArticles.slice(0, this.renderedArticleCount);
        },
        localStorageSupport() {
            let support = typeof localStorage !== 'undefined';
            try {
                localStorage.setItem('_', '');
            } catch (e) {
                support = false;
            }
            return support;
        },
        skipCount() {
            if (document.referrer !== '' || !this.localStorageSupport) {
                return 0;
            }
            let index = localStorage.getItem('nextSkip') || 0;
            index = parseInt(index);
            if (index === 0 || index > this.articles.length) {
                localStorage.setItem('nextSkip', '6');
                return 0;
            }
            localStorage.setItem('nextSkip', (index + 6).toString());
            return index;
        },
        newArticles() {
            let newArticles = [...this.articles];
            const skippedArticles = newArticles.splice(0, this.skipCount);
            return [...newArticles, ...skippedArticles];
        }
    },
    methods: {
        renderMoreArticles() {
            this.renderedArticleCount += this.MORE_VIEW_SIZE;
            if (this.renderedArticleCount > this.newArticles.length) {
                this.renderedArticleCount = this.newArticles.length;
            }
        },
        createFeedbackData() {
            const viewableArticles = this.$refs.articleElements.map((element, index) => {
                const article = this.newArticles[index];
                return {
                    itemid: `/${article.grpcode}/${article.fldid}/${article.dataid}`,
                    pos: index,
                    viewable: element.$el.offsetTop < $(document).scrollTop() + $(window).height(),
                    sent: !!article.sent
                }
            }).filter((item, index) => {
                if (!item.viewable || item.sent) {
                    return false;
                }
                this.newArticles[index].sent = true;
                return true;
            });
            const items = viewableArticles.map((item) => ({
                itemid: item.itemid,
                pos: item.pos
            }));
            return {
                source: location.pathname,
                bucket: this.newArticles[0].bucket,
                items
            }
        }
    },
    mounted() {
        if (this.config.isPopularArticle) {
            // 2.5초 마다 뷰어블 이벤트 전송
            setInterval(() => {
                const feedbackData = this.createFeedbackData();
                if (!feedbackData.items.length) {
                    return;
                }
                axios.post('/toros/usage/event/viewable', feedbackData, {
                    headers: { 'content-type': 'application/json; charset=utf-8' },
                });
            }, 2500);
        }
    }
}
</script>
